import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

export class Benefit {
  benefit_Branch: any = [];
  benefit_discount: string;
  benefit_type: string;
  branch: any;
  categories: any = [];
  category: Category;
  codes_left: number;
  codes_length: number;
  date_from: string;
  date_to: string;
  days: string;
  description: string;
  description_disclaimer: string;
  discount: number;
  iD_Category: number;
  iD_Partner: number;
  id: number;
  keywords: string;
  legales: string;
  name: string;
  partner: Partner;
  photo: string;
  photo_mobile: string;
  starred_category: boolean;
  starred_home: boolean;
  thumb: any;
  typete: string;
  url: string;
  instructions: string;
  redeemCodes: boolean;
}

export class Category {
  benefit: [];
  id: number;
  name: string;
  photo: string;
}

export class Partner {
  branch: any;
  id: number;
  logo: string;
  name: string;
  url_link: any;
}

@Injectable({
  providedIn: 'root'
})


export class BenefitsService {

  selectedBenefit: any  = null;
  benefitsUrl           =  environment.API_URL+ "/benefit";
  benefitsByName        =  environment.API_URL+"/Benefit/getByName";
  codeUrl               =  environment.API_URL+"/Benefit/getCode";
  benefitsFilter        =  environment.API_URL+"/Benefit/list/benefits";
  movements             =  environment.API_URL+"/auth/getMovimientos";

  url_filters: string[] = [];

  data_latitud: string | null = null;
  data_longitud: string | null = null;
  data_category: number[] = [];
  data_modoUso: number[] = [];
  data_tipoBeneficio: number[] = [];
  data_diasValidez: number[] = [];
  data_mapa: boolean = false;
  data_ordenamiento: number= 0;
  benefit                 = <any>null;
  benefitCode:string | null             = '';
  showModal               = false;




  constructor(private http:           HttpClient,
              private userService:    AuthService,
              private spinnerService: NgxSpinnerService,
              private router : Router,
              )
  {
  }


  getMovements()
  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    })
    return this.http.get(this.movements,{ headers: headers });
  }
  selectBenefit(benefit: any)
  {
    this.selectedBenefit = benefit;
  }
  getSelectedBenefit()
  {
    return this.selectedBenefit;
  }
  get()
  {
    return this.http.get(this.benefitsUrl);
  }
  getById(id: number)
  {
    return this.http.get(this.benefitsUrl + '/' + id);
  }
  getByName(name: string)
  {
    return this.http.get(this.benefitsByName + '?name=' + name);
  }
  clearFilters(){
    this.data_category = [];
    this.data_modoUso = [];
    this.data_tipoBeneficio = [];
    this.data_diasValidez = [];
    this.data_mapa = false;
    this.data_ordenamiento = 0;
    this.url_filters = [];
  }
  getCode(person: any, benefit: any, deviceValue: any )
  {
    const ID_Benefit = benefit.id;
    const device     = deviceValue;
    const data       = {ID_Benefit, device };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    })

    return this.http.post(this.codeUrl, data, {headers: headers});
  }
  async benefitCodes (benefit: Benefit): Promise<string>{
    return new Promise(async (resolve, reject) => {
      let code: any;

    if (sessionStorage.getItem('benefit-' + benefit.id) != null){
      code = await sessionStorage.getItem('benefit-' + benefit.id)

      resolve(code);
    }else{
      let user = await this.userService.getCurrentUser();
      this.getCode(user.person.profile, benefit, 'desktop device')
      .subscribe({
        next: async (response: any) => {
          await sessionStorage.setItem('benefit-' + benefit.id, response?.code)

          resolve(response?.code)
        },
        error: (err:any) => {
          reject(err)
        }
      })
    }
    })
  }

  getCodesByUser(dni: number)
  {
    const codesUrl = environment.API_URL+"/Benefit/GetCodesByUser";
    return this.http.post(codesUrl, {DNI: dni});
  }

  filterBenefits(lat?: string | null, lon?: string | null, map?: boolean, ord?:number, keywords?:string | null)
  {
    const cat = this.data_category.length == 0 ? null : this.data_category;
    const mod = this.data_modoUso.length == 0 ? null : this.data_modoUso;
    const dia = this.data_diasValidez.length == 0 ? null : this.data_diasValidez;
    const benefit = this.data_tipoBeneficio.length == 0 ? null : this.data_tipoBeneficio;
    const orden = ord;
    const keyword = (keywords != null && keywords.length > 0) ? keywords : null;

    const data = {latitud: lat, longitud: lon, category: cat, ModoUso: mod, DiasValidez: dia, TipoBeneficio: benefit, ordenamiento: orden, mapa: map, keywords: keyword}
    return this.http.post(this.benefitsFilter, data)
  }

  filter_benefits(filters: any){
    if (filters) {
      var filterString = filters.join("-");
      this.router.navigate(['/beneficios-y-descuentos/' + filterString])
    } else {
      this.router.navigate(['beneficios-y-descuentos']);
    }
  }

  filterCategories(filters: any){
    if (filters) {
      var filterString = filters.join("-");
      this.router.navigate(['/festividades/' + filterString])
    } else {
      this.router.navigate(['festividades']);
    }
  }

  getByCategory(category: any){
    const data = {
      category: [category.id],
      ordenamiento: 0
    }

    return this.http.post(this.benefitsFilter, data)
  }

  getBenefitUrl(benefit: any){
    const cateogry = this.getCategoryForUrl(benefit.category.name);
    const url = '/beneficios-y-descuentos/' + cateogry + '/' + benefit.name;

    return url;
  }

  getCategoryForUrl(category: string){
    return category.toLowerCase().replace(/ /g, '-').replace(/ó/g, 'o').replace(/í/g, 'i').replace(/é/g, 'e').replace(/á/g, 'a').replace(/ñ/g, 'n').replace(/ú/g, 'u');
  }
}


